<template>
    <div class="out">
        <div class="header-button-box">
            <el-button type="primary" @click="Outofstock">出库</el-button>
            <el-button type="primary" @click="Outofstocks">批量出库</el-button>
            <el-button type="primary" @click="unkonwnClick">未知记录</el-button>
        </div>
        <slot name="formScreen"></slot>
        <el-table :data="listTable" border style="width: 100%" :header-cell-style="{ textAlign: 'center' }" v-loading="loadingTable">
            <el-table-column prop="conveyNumber" label="国际运单" align="center"></el-table-column>
            <el-table-column prop="orderId" label="订单号/订单ID" width="240" align="left">
                <template slot-scope="scope">
                    <div>订单号：{{ scope.row.amazonOrderId }}</div>
                    <div>订单ID：{{ scope.row.orderId }}</div>
                    <el-row style="display: flex;align-items: center;">
                        <el-popover placement="top-start" title="物流内部备注" width="650" trigger="hover">
                            <el-table :data="RemarkList" style="width: 100%">
                                <el-table-column prop="roleName" label="添加人" width="120" align="center"></el-table-column>
                                <el-table-column prop="remarkContent" label="内容" width="330" align="center"></el-table-column>
                                <el-table-column prop="createTime" label="时间" width="200" align="center"></el-table-column>
                            </el-table>
                        <i class="el-icon-s-order" style="font-size:18px;" slot="reference" @mouseover="orderIdchange(scope.row)"></i>
                        </el-popover>
                        <el-tag v-if="scope.row.outInterceptStatus === 1" type="danger" effect="dark" size="mini">拦截</el-tag>
                        <el-tooltip class="item" effect="dark" content="订单冻结" placement="bottom" v-if="scope.row.isFreeze === 1">
                            <i class="element-icons hx-snow" style="font-size: 40px;color: #1296db;line-height: 40px;"></i>
                        </el-tooltip>
                    </el-row>
                    
                </template>
            </el-table-column>
            <el-table-column prop="applyVolume" label="尺寸" align="center"></el-table-column>
            <el-table-column prop="applyWeight" label="重量" align="center"></el-table-column>
            <el-table-column prop="channelName" label="渠道" align="center"></el-table-column>
            <!-- <el-table-column prop="branchCompanyName" label="所属分公司" width="200" align="center"></el-table-column>
            <el-table-column prop="subCompanyName" label="所属子公司" width="200" align="center"></el-table-column> -->
            <el-table-column width="200" prop="ziName" label="所属公司" align="center">
                <template slot-scope="scope">
                    <div>
                        <span>{{ scope.row.branchCompanyName }}</span>
                        <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
                        <span>{{ scope.row.subCompanyName }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="80" align="center">
                <template slot-scope="scope">
                    <i class="el-icon-edit-outline fontSize-30" @click="edit(scope.row)"></i>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20, 50, 100, 200, 300]"
                :page-size="size"
                layout="total, sizes,prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </div>
        <!-- 出库 -->
        <Outofstock ref="Outofstock" @confirm="OutofstockDetermine" />
        <Outofstocks ref="Outofstocks" @confirm="OutofstockDetermines" />
        <!-- 信息核对 -->
        <Informationcheck ref="Informationcheck" @confirm="InformationcheckConfirm" />
        <!-- 未知记录 -->
        <el-dialog title="未知记录" :visible.sync="dialogTableVisible" width="40%" top="4vh">
            <el-table :data="listUnknown" border>
                <el-table-column property="internalConveyNumber" label="未知单号" align="center"></el-table-column>
                <el-table-column property="outStorageTime" label="出库时间" align="center"></el-table-column>
                <el-table-column property="unknownType" label="类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.unknownType === 1">未知</span>
                        <span v-else-if="scope.row.unknownType === 2">重复</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="delUnknown(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="warning" @click="clearUnknown">清 空</el-button>
                <el-button type="primary" @click="dialogTableVisible = false">完 成</el-button>
            </span>
        </el-dialog>
        <!-- 未知记录 -->
    </div>
</template>

<script>
import Outofstock from "./Outofstock"; //出库
import Outofstocks from "./Outofstocks"; //出库
import Informationcheck from "./Informationcheck";

import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
    name: "out",
    props: {
        UserInfo: {
            type: Object,
            default() {
                return {};
            },
        },
        formScreenData: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    components: {
        Outofstock,
        Outofstocks,
        Informationcheck,
    },
    data() {
        return {
            listTable: [],
            page: 1,
            size: 20,
            total: 0,
            dialogTableVisible: false,
            listUnknown: [],
            loadingTable: false,
            RemarkList:[],
        };
    },
    methods: {
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.page = val;
            this.getTableData();
        },
        Outofstock() {
            this.$refs.Outofstock.init();
        },
        Outofstocks() {
            this.$refs.Outofstocks.init();
        },
        // 出库保存
        OutofstockDetermine(data) {
            const API = Baseurl + "logisticsController/channelOrderOutStorage";
            const orderChannels = JSON.parse(JSON.stringify(data));
            orderChannels.forEach(item => {
                delete item.isEdit;
                delete item.id;
            });
            const paramsData = {
                roleId: this.UserInfo.rid,
                orderChannels,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                this.$refs.Informationcheck.loading = false
                if (code === 200) {
                    const { correctCount, errorCount } = data
                    this.$refs.Outofstock.closeLoading();
                    this.$refs.Informationcheck.close();
                    this.getTableData();
                    // this.$message.success("操作成功");
                    this.$message.success(`共${correctCount + errorCount}条，成功出库${correctCount}条，失败${errorCount}条。`);
                } else {
                    this.$message.error(res.data.data);
                }
            });
        },
        // 出库保存
        OutofstockDetermines(data) {
            const API = Baseurl + "logisticsController/channelOrderOutStorage";
            const orderChannels = JSON.parse(JSON.stringify(data));
            orderChannels.forEach(item => {
                delete item.isEdit;
                delete item.id;
            });
            const paramsData = {
                roleId: this.UserInfo.rid,
                orderChannels,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                this.$refs.Informationcheck.loading = false
                if (code === 200) {
                    const { correctCount, errorCount } = data
                    this.$refs.Outofstocks.closeLoading();
                    this.$refs.Informationcheck.close();
                    this.getTableData();
                    // this.$message.success("操作成功");
                    this.$message.success(`共${correctCount + errorCount}条，成功出库${correctCount}条，失败${errorCount}条。`);
                } else {
                    this.$message.error(res.data.data);
                }
            });
        },

        edit(row) {
            this.$refs.Informationcheck.init("out", row);
        },
      searchForm() {
          this.page = 1
          this.getTableData()
      },
        getTableData() {
            const API = Baseurl + "logisticsController/getConveyNumberList";
            const paramsData = {
                page: this.page,
                size: this.size,
                ...this.formScreenData,
            };
            this.loadingTable = true
            ajaxPost(API, paramsData).then(res => {
              this.loadingTable = false
                const { code, data } = res.data;
                if (code === 200) {
                    this.listTable = data.list;
                    this.total = data.total;
                }
            });
        },
        InformationcheckConfirm(data) {
            this.OutofstockDetermine(data);
        },
        unkonwnClick() {
            const API = Baseurl + "logisticsController/getUnknownOutStorageList";

            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.listUnknown = data;
                    this.dialogTableVisible = true;
                }
            });
        },
        delUnknown(val){
            this.$confirm('确定要删除吗？','提示').then(() => {
                let API = Baseurl + "logisticsController/deleteUnknownPurchase";
                let paramsData = { id: val.id };
                if (val.unknownType === 2) {
                    API = Baseurl + "logisticsController/deleteUnknownOutStorage";
                    delete paramsData.id
                    paramsData = {
                        internalConveyNumber: val.internalConveyNumber
                    }
                }
                
                ajaxPost(API, paramsData).then(res => {
                    const { code } = res.data;
                    if (code === 200) {
                        this.$message.success("删除成功！");
                        this.unkonwnClick();
                    } else {
                        this.$message.error("删除失败！");
                    }
                });
            })
        },
        clearUnknown() {
            this.$confirm('确定要清空吗？','提示').then(() => {
                const API = Baseurl + "logisticsController/emptyUnknownOutStorage";
                const paramsData = { unknownPurchases: this.listUnknown };
                ajaxPost(API, paramsData).then(res => {
                    const { code } = res.data;
                    if (code === 200) {
                        this.$message.success("操作成功！");
                        this.unkonwnClick();
                    } else {
                        this.$message.error("操作错误！");
                    }
                });
            })
        },
        orderIdchange(val){
            const API = Baseurl + 'logisticsRemarkController/selectLogisticsRemarkList'
            const paramsData = {
                orderId: val.orderId
            }
            ajaxPost(API, paramsData).then(res => {
                if (res.data.code === 200) {
                this.RemarkList = res.data.data
                } else {
                this.$message.error(res.data.data)
                }
            })
            }
        },
};
</script>

<style lang="scss" scoped>
.out {
    padding-bottom: 72px;
    .header-button-box {
        margin: 10px 0;
    }
    .custom-out-form {
        .el-form-item {
            margin: 0;
        }
    }
    .pagination-container {
        width: 1660px;
        padding: 20px;
        position: fixed;
        right: 0;
        bottom: 0;
        background: #fff;
        z-index: 999;
        .el-pagination {
            display: flex;
            justify-content: center;
        }
    }
}
</style>
